import $ from 'jquery'; // eslint-disable-line no-restricted-imports
import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.field-current-ndvi', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/field-current-ndvi');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- Report widget failure.
    }
  })();
});

onElelementExistRunOnce('.field-dashboards-monitoring-page', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/field-dashboards-monitoring-page');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- Report widget failure.
    }
  })();
});

onElelementExistRunOnce('.machinery_tasks_list', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/machinery_tasks_list');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- Report widget failure.
    }
  })();
});

onElelementExistRunOnce('.widget_field_scout_reports', () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/widget_field_scout_reports');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- Report widget failure.
    }
  })();
});

const selector = '.widget_total_fertilizers';

onElelementExistRunOnce(selector, () => {
  void (async () => {
    try {
      const { default: Component } = await import('./internal/widget_total_fertilizers');
      await Promise.resolve(Component());
    } catch (error) {
      console.error(error); // eslint-disable-line no-console -- report failed page initialization
    }
  })();

  $('.link-with-popover[data-toggle="popover"]').popover();
});
